




















































































































import { Component, Vue } from 'vue-property-decorator'
import VButton from '@/components/VButton.vue'
import VInput from '@/components/VInput.vue'
import PromoCard from '@/components/PromoCard.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/account/types'
import ValidatedForm from '@/utilities/validation/validatedform'
import FormField from '@/utilities/validation/formfield'
import nonEmptyValidator from '@/utilities/validators/nonempty'
import emailValidator from '@/utilities/validators/email'
import translator from '@/utilities/translator'

@Component({ components: { PromoCard, VButton, VInput } })
export default class Home extends Vue {
  @Action('login', { namespace: 'account' }) private login!: types.LoginAction
  @Action('userExists', { namespace: 'account' }) private userExists!: types.UserExistsAction

  private showRegister = false;
  private showRegister2 = false;
  private email = new FormField(emailValidator, '')

  private registerForm: ValidatedForm = new ValidatedForm({
    name: new FormField(nonEmptyValidator, ''),
    email: this.email
  })

  private goingToRegister = false
  private existsError = false

  private goToRegister () {
    if (this.registerForm.validateForm()) {
      this.goingToRegister = true
      this.userExists(this.registerForm.fields.email.value).then((response) => {
        if (!response.exists) {
          this.$router.push({
            name: 'register',
            params: {
              name: this.registerForm.fields.name.value,
              email: this.registerForm.fields.email.value
            }
          })
        } else {
          this.email.serverError = (translator as any).forms.emailExists
        }
      }).finally(() => {
        this.goingToRegister = false
      })
    }
  }
}
